var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D1FADF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6192 15.238V13.3332C27.6192 12.2828 26.7649 11.4285 25.7144 11.4285H13.3335C11.7582 11.4285 10.4763 12.7104 10.4763 14.2856V25.7142C10.4763 27.8104 12.1849 28.5713 13.3335 28.5713H27.6192C28.6696 28.5713 29.5239 27.717 29.5239 26.6666V17.1428C29.5239 16.0923 28.6696 15.238 27.6192 15.238ZM25.7144 23.8094H23.8097V19.9999H25.7144V23.8094ZM13.3335 15.238C13.0882 15.227 12.8567 15.1219 12.6871 14.9445C12.5174 14.7671 12.4227 14.5311 12.4227 14.2856C12.4227 14.0401 12.5174 13.8041 12.6871 13.6267C12.8567 13.4493 13.0882 13.3442 13.3335 13.3332H25.7144V15.238H13.3335Z",
    fill: "#027948"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2858 24.5716C22.2858 20.7845 19.2158 17.7144 15.4287 17.7144C11.6416 17.7144 8.57153 20.7845 8.57153 24.5716C8.57153 28.3587 11.6416 31.4287 15.4287 31.4287C19.2158 31.4287 22.2858 28.3587 22.2858 24.5716ZM14.8226 21.394L12.2512 23.9655C11.9164 24.3002 11.9164 24.8429 12.2512 25.1777C12.5859 25.5124 13.1286 25.5124 13.4633 25.1777L14.5715 24.0695L14.5715 27.143C14.5715 27.6164 14.9553 28.0001 15.4287 28.0001C15.9021 28.0001 16.2858 27.6164 16.2858 27.143L16.2858 24.0695L17.394 25.1777C17.7287 25.5124 18.2715 25.5124 18.6062 25.1777C18.9409 24.8429 18.9409 24.3002 18.6062 23.9655L16.0348 21.394C15.7 21.0593 15.1573 21.0593 14.8226 21.394Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenWallet);
export default __webpack_public_path__ + "static/media/green-wallet.4721c65d8f6f670a56bbb31e69811081.svg";
export { ForwardRef as ReactComponent };